(function() {
'use strict';

    angular
        .module('app')
        .controller('bulletinDetailController', bulletinDetailController);

    function bulletinDetailController(viewModel) {
        var vm = this;
        vm.data=viewModel.data;
    }
})();